import { takeLatest, put, call } from 'redux-saga/effects';

import { CONFIG_SESSION } from '@handler/common/startSession';
import { storage } from '@commons/storage';
import { formatDateDDMMYYYY } from '@components/common/format';
import {
  GET_LOADING_COLHEITA_SUCCESS,
  GET_LOADING_COLHEITA_PENDING,
  RELATORIO_COLHEITA,
} from '../actionTypes';
import { CONST_FILTER_COLHEITA } from '@commons/consts';
import { getRelatorioColheita, getRelatorioColheitaExcel } from '../service';

function* sagaRelatorioColheita(action) {
  yield put({ type: GET_LOADING_COLHEITA_PENDING })

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;
    const idSafraAtiva = JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva?.id ?? -1;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_COLHEITA) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_COLHEITA)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    if (action.pdf === undefined || action.pdf === null || action.pdf) {
      yield call(getRelatorioColheita, idFazenda, idSafraAtiva, datas, filterSaved.where)
    } else {
      yield call(getRelatorioColheitaExcel, idFazenda, idSafraAtiva, datas, filterSaved.where)
    }

    yield put({
      type: GET_LOADING_COLHEITA_SUCCESS
    });
  } catch (error) {
    yield put({ type: GET_LOADING_COLHEITA_SUCCESS })
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchRelatorioColheita() {
  yield takeLatest(RELATORIO_COLHEITA, sagaRelatorioColheita)
}